import { render, staticRenderFns } from "./ReceivingAddress.vue?vue&type=template&id=a7f20d02&scoped=true&"
import script from "./ReceivingAddress.vue?vue&type=script&lang=js&"
export * from "./ReceivingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingAddress.vue?vue&type=style&index=0&id=a7f20d02&lang=scss&scoped=true&"
import style1 from "./ReceivingAddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f20d02",
  null
  
)

export default component.exports